<template>
  <div id="app">
    <Navbar />
    <router-view/>
    <Footer />
  </div>
</template>

<script>

import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'

export default {

  name: 'App',

  components: { Navbar, Footer }

}

</script>

<style lang="less">
  * {
    font-family: 'DM Sans';
  }
  #app {
    background-color: #f6f6f6;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue